import { render, staticRenderFns } from "./AdAlertConfirm.vue?vue&type=template&id=f21c8faa"
import script from "./AdAlertConfirm.vue?vue&type=script&lang=js"
export * from "./AdAlertConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports